<script setup lang="ts">
import { ref } from "vue";

import { type Handshake, readHandshake } from "./handshake";
import ConnectView from "./views/ConnectView.vue";
import MarketingView from "./views/MarketingView.vue";

const handshake = ref<Handshake | null>(readHandshake(window.location.search));
</script>

<template>
  <UApp>
    <ConnectView
      v-if="handshake"
      :handshake="handshake"
    />
    <MarketingView v-else />
  </UApp>
</template>
